import { FilterType } from "types/enums";
import { addPcreRegexIssue } from "utils/regexValidation";
import { z } from "zod";

export const OUTPUT2_ENABLED_OPERATORS = [FilterType.IsBetween, FilterType.IsBetweenEquals];

export const NO_OUTPUT_OPERATORS = [FilterType.IsEmpty, FilterType.IsNotEmpty, FilterType.IsTrue, FilterType.IsFalse];

export const REGEX_OPERATORS = [FilterType.RegexMatch, FilterType.RegexNotMatch];

const NS = "components.connection-creator.edges.condition.forms";

export const conditionFormSchema = z.object({
    active: z.boolean(),
    title: z.string(),
    subtitle: z.string(),
    result: z.string(),
    conditions: z.array(
        z
            .object({
                value: z.string(),
                operator: z.string().min(1, `${NS}.operator_required`),
                output: z.string(),
                output2: z.string(),
            })
            .superRefine((val, ctx) => {
                if (!val.value.trim()) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        path: ["value"],
                        message: `${NS}.value_required`,
                    });
                }

                if (!NO_OUTPUT_OPERATORS.includes(val.operator as FilterType) && !val.output.trim()) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        path: ["output"],
                        message: `${NS}.output_required`,
                    });
                } else if (REGEX_OPERATORS.includes(val.operator as FilterType)) {
                    addPcreRegexIssue(val.output, ctx, ["output"]);
                }

                if (OUTPUT2_ENABLED_OPERATORS.includes(val.operator as FilterType) && !val.output2.trim()) {
                    ctx.addIssue({
                        code: z.ZodIssueCode.too_small,
                        minimum: 1,
                        type: "string",
                        inclusive: true,
                        path: ["output2"],
                        message: `${NS}.output2_required`,
                    });
                }
            })
    ),
});

export const conditionFormDefaultValues = {
    active: true,
    title: "",
    subtitle: "",
    result: "success",
    conditions: [{ value: "", operator: "", output: "", output2: "" }],
};
